export enum AccountReportStatusTypes {
  Failed = -1,
  Initialed = 0,
  Generated = 10,
  MailSent = 20,
}

export const AccountReportStatusOptions = [
  { value: AccountReportStatusTypes.Failed, label: "Failed" },
  { value: AccountReportStatusTypes.Initialed, label: "Initialed" },
  { value: AccountReportStatusTypes.Generated, label: "Generated" },
  { value: AccountReportStatusTypes.MailSent, label: "Mail Sent" },
];
